import {
  AvailablePaymentCurrency,
  IsoLocale,
  formatCurrencyAmount,
  getDollarValue,
  DiscountType,
} from "@simplyk/common";

import { DiscountOutput } from "@/types/trpc";

export const applyDiscountOnOrderValue = (validDiscount: DiscountOutput | null, ticketsPrice: number) => {
  return Math.max(ticketsPrice - getDiscountAmount(validDiscount, ticketsPrice), 0);
};

export const getDiscountAmount = (validDiscount: DiscountOutput | null, ticketsPrice: number) => {
  if (!validDiscount) {
    return 0;
  }
  if (validDiscount.type === DiscountType.Dollars) {
    return validDiscount.amount;
  }
  return Math.round((ticketsPrice * validDiscount.amount) / 100);
};

export const getDiscountReduction = (
  validDiscount: DiscountOutput,
  isoLocale: IsoLocale,
  currency: AvailablePaymentCurrency
) => {
  if (!validDiscount) {
    return "";
  }
  if (validDiscount.type === DiscountType.Dollars) {
    return formatCurrencyAmount({ value: getDollarValue(-validDiscount.amount), locale: isoLocale, currency });
  }
  return `-${validDiscount.amount}%`;
};
